import { Component, Input } from '@angular/core';
import { Student } from 'src/app/model/student/student.model';
import { ChildrenDeduplicationCompareModalComponent } from './children-deduplication-compare-modal/children-deduplication-compare-modal.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
    selector: 'children-deduplication-compare-btn',
    templateUrl: './children-deduplication-compare-btn.component.html',
    styleUrls: ['./children-deduplication-compare-btn.component.scss']
})
export class ChildrenDeduplicationCompareBtnComponent {
    @Input() studentId1!: number;
    @Input() studentId2!: number;

    constructor(private dialog: MatDialog) {}

    ngOnInit(): void {}

    // Dialog Modal
    openDialog() {
        let payload: any = {};
        payload.studentId1 = this.studentId1;
        payload.studentId2 = this.studentId2;

        const dialogConfig = new MatDialogConfig();
        //dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '90vw';
        const dialogRef = this.dialog.open(ChildrenDeduplicationCompareModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
                console.log(res.msg);
            }
        });
    }
}
